import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const EntertainmentsIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="22" height="22" viewBox="0 0 22 22">
		<g transform="translate(-40 -309)">
			<path d="M11,0A11,11,0,1,1,0,11,11,11,0,0,1,11,0Z" transform="translate(40 309)" fill="#ffe200" />
			<path d="M-1607-3319a8.007,8.007,0,0,1-7.937-7h15.875A8.007,8.007,0,0,1-1607-3319Z" transform="translate(1658 3647)" fill="#6f8728" />
			<path
				d="M-1616.469-3332.5H-1618a2.536,2.536,0,0,1,.763-1.769,2.537,2.537,0,0,1,1.787-.73,2.536,2.536,0,0,1,1.786.73,2.537,2.537,0,0,1,.762,1.768h-1.53a1.016,1.016,0,0,0-.305-.707,1.014,1.014,0,0,0-.715-.292,1.013,1.013,0,0,0-.714.292,1.01,1.01,0,0,0-.305.707Z"
				transform="translate(1662 3649.5)"
				fill="#6f8728"
			/>
			<path
				d="M-1616.469-3332.5H-1618a2.536,2.536,0,0,1,.763-1.769,2.537,2.537,0,0,1,1.787-.73,2.536,2.536,0,0,1,1.786.73,2.537,2.537,0,0,1,.762,1.768h-1.53a1.016,1.016,0,0,0-.305-.707,1.014,1.014,0,0,0-.715-.292,1.013,1.013,0,0,0-.714.292,1.01,1.01,0,0,0-.305.707Z"
				transform="translate(1671 3649.5)"
				fill="#6f8728"
			/>
			<path
				d="M-1615.971-3330.61a11.217,11.217,0,0,1,5.909-1.391,11.218,11.218,0,0,1,5.909,1.391,8,8,0,0,1-5.91,2.608A8,8,0,0,1-1615.971-3330.61Z"
				transform="translate(1661.063 3656)"
				fill="#5e7222"
			/>
		</g>
	</svg>
);
